import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 10.5V6H3v12h14v-4.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
}), 'VideoCallSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideoCallSharp.js
// module id = 7038
// module chunks = 2